import React, { useState } from "react";
import {
  Typography,
  Box,
  Container,
  Paper,
  Grid,
  Button,
} from "@mui/material";
import { styled } from "@mui/system";
// import Sidebar from "../sidebar/Sidebar";
// import Navbar from "../sidebar/Navbar";
import Navbar from "../sidebar/SideNavbar";

const Header = styled(Box)(({ theme }) => ({
  backgroundColor: "#ff8c00",
  color: "white",
  padding: theme.spacing(2),
  display: "flex",
  alignItems: "center",
}));



export default function PrivacyPolicy() {
  const [privacyPolicy, setPrivacyPolicy] = useState(true);
  const [shippingPolicy, setShippingPolicy] = useState(false);
  const [refundPolicy, setRefundPolicy] = useState(false); // Default policy shown

  const handlePrivacyPolicy = () => {
    setPrivacyPolicy(true);
    setShippingPolicy(false);
    setRefundPolicy(false);
  };

  const handleShippingPolicy = () => {
    setPrivacyPolicy(false);
    setShippingPolicy(true);
    setRefundPolicy(false);
  };

  const handleRefundPolicy = () => {
    setPrivacyPolicy(false);
    setShippingPolicy(false);
    setRefundPolicy(true);
  };

  return (
    <div style={{ display: "flex", background: "#F5F5F5" }}>
      <Navbar />
      {/* <Sidebar /> */}
      <main style={{ flexGrow: 1, padding: '5px', minHeight: '100vh' }}>
     
      <Container
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            minHeight: 'calc(100vh - 64px)', 
            margin: 'auto', 
            maxWidth: 'lg', 
            height: '100vh',
          }}
        >
        <Box sx={{ paddingTop: 10}}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Paper>
                <Header sx={{ display: "flex", justifyContent: "center" }}>
                  <Typography variant="h5">Terms and Conditions</Typography>
                </Header>
              
                {/* Navigation Buttons */}
                <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 2 }}>
                  <Button
                    variant="contained"
                    onClick={handlePrivacyPolicy}
                    sx={{ height: "40px" }}
                  >
                    Privacy Policy
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleShippingPolicy}
                    sx={{ height: "40px" }}
                  >
                    Shipping & Delivery Policy
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleRefundPolicy}
                    sx={{ height: "40px" }}
                  >
                    Cancellation & Refund Policy
                  </Button>
                </Box>
               
                {/* Conditional Rendering of Policies */}
                {refundPolicy && (
                  <Box sx={{ mt: 3,width: '100%' }}>
                    
                    <Typography variant="h5" sx={{ color: "black", padding: "2px" }}>
                        Cancellation & Refund Policy
                    </Typography>
                      <div style={{ padding: "10px", height: "50vh", overflowY: "auto" }}>
                      <Typography>
                        <b>1. Refund of Account Balance:</b>
                        <p style={{ textAlign: 'justify' }}>
                        Subscriber of the Operators under <strong>{localStorage.getItem("network_name")}</strong> (‘Company’) will be eligible to receive a refund of the Account Balance (‘Refund’) as per the terms provided in this Refund Policy.
                        </p>
                        <p style={{ textAlign: 'justify' }}>
                        Subscribers will be eligible to receive a Refund of their Account Balance on deactivation/termination of his/her Subscriber Account (‘Cancellation’). Subscriber may cancel or completely discontinue availing all the Services provided by the Company by contacting the Company. However, Company reserves the right to refuse such deactivation request if the subscription of any of the Service is within the lock-in period or minimum period guarantee which was declared by the Company related to a specific Scheme. In such an instance the Company reserves the right to make the Cancellation request made by the Subscriber, effective from the date on which such lock-in period or minimum period guarantee comes to an end.
                        </p>
                        <b>2. No Refund in the following cases:</b>
                        <p style={{ textAlign: 'justify' }}>
                        On suspension of a particular Service for a temporary period when requested by a Subscriber;                </p>
                        <p style={{ textAlign: 'justify' }}>
                        Suspension of Service by the Company:<br/>
                        (i)to carry out maintenance or testing;<br/>
                        (ii) to safeguard the security and integrity of the Services or for technical purposes;<br/>
                        (iii) if so directed by the government.
                        </p>
                        <b>3. How to Cancel Subscriber Account?</b>
                        <p style={{ textAlign: 'justify' }}>
                        To cancel his/her Subscriber Account Subscriber can place a request for Cancellation with the Company by any of the following methods:
                        </p>
                        <p style={{ textAlign: 'justify' }}>By calling the respective operators support numbers or<br/>
                        By Emailing to the email id provided in the payment page; or<br/>
                        By contacting the respective collection agents.</p>
                        <b>4. Process of Refund:</b>
                        <p style={{ textAlign: 'justify' }}>Subscriber must initiate the Cancellation request by any one of the methods as provided in para ‘3’ above;</p>
                        <p style={{ textAlign: 'justify' }}>Company shall process the Refund to Subscriber’s bank account hence Subscriber must submit a copy of the cancelled cheque to the Company to initiate NEFT and any other information/documents as required by the Company;</p>
                        <p style={{ textAlign: 'justify' }}>Company will process the Refund amount within 20 Business Days of receipt of the Cancellation request, required documents and successful return of CPE by Subscriber to the Company (if applicable).</p>
                        </Typography>
                      </div>
                  </Box>
                )}

                {shippingPolicy && (
                  <Box sx={{ mt: 3,width: '100%' }}>
                    <Typography variant="h5" sx={{ color: "black", padding: "2px" }}>
                        Shipping & Delivery Policy
                    </Typography>
                      <div style={{ padding: "10px", height: "50vh", overflowY: "auto" }}>
                      <Typography>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}>
                        For International buyers, orders are shipped and delivered through registered international courier companies and/or International speed post only. For domestic buyers, orders are shipped through registered domestic courier companies and /or speed post only. Orders are shipped within 0-2 Days or as per the delivery date agreed at the time of order confirmation and delivering of the shipment subject to Courier Company / post office norms.
                        </p>
                        <p style={{ textAlign: 'justify' }}>
                        <strong>{localStorage.getItem("network_name")}</strong> is not liable for any delay in delivery by the courier company / 
                        postal authorities and only guarantees to hand over the consignment to the courier company or postal authorities within 0-2 Days from the date of the order and payment or as per the delivery date agreed at the time of order confirmation. Delivery of all orders will be to the address provided by the buyer. Delivery of our services will be confirmed on your mail ID as specified during registration. For any issues in utilizing our services you may contact our helpdesk on <strong>{localStorage.getItem("op_phone")} or {localStorage.getItem("op_email")}.</strong>
                        </p>
                        </Typography>
                      </div>
                  </Box>
                )}

                {privacyPolicy && (
                  <Box sx={{ mt: 3,width: '100%' }}>
                    <Typography variant="h5" sx={{ color: "black", padding: "2px" }}>
                        Privacy Policy
                    </Typography>
                    <div style={{ padding: "8px", height: "50vh", overflowY: "auto" }}>
                    <Typography>
                    <p style={{ marginLeft: '2px', textAlign: 'justify' }}>
                        This privacy policy (“Policy”) relates to the manner <strong>{localStorage.getItem("network_name")}</strong> (“we”, “us”, “our”) in which we use, handle and process the data that you provide us in connection with using the products or services we offer. By using this website or by availing goods or services offered by us, you agree to the terms and conditions of this Policy, and consent to our use, storage, disclosure, and transfer of your information or data in the manner described in this Policy.
                        </p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}>
                        We are committed to ensuring that your privacy is protected in accordance with applicable laws and regulations. We urge you to acquaint yourself with this Policy to familiarize yourself with the manner in which your data is being handled by us.
                        </p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}>
                        <strong>{localStorage.getItem("network_name")}</strong> may change this Policy periodically and we urge you to check this page for the latest version of the Policy in order to keep yourself updated.
                        </p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}><b>What data is being collected</b></p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}>We may collect the following information from you:</p>
                        <ul>
                        <li>Name</li>
                        <li>Contact information including address and email address</li>
                        <li>Demographic information or, preferences or interests</li>
                        <li>Personal Data or Other information relevant/ required for providing the goods or services to you</li>
                        <li>The meaning of Personal Data will be as defined under relevant Indian laws</li>
                        </ul>
                        <br/>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}>
                        <strong>Note:</strong> Notwithstanding anything under this Policy as required under applicable Indian laws, we will not be storing any credit card, debit card or any other similar card data of yours. Please also note that all data or information collected from you will be strictly in accordance with applicable laws and guidelines.
                        </p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}><strong>What we do with the data we gather</strong></p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}>
                        We require this data to provide you with the goods or services offered by us including but not limited, for the below set out purposes:
                        </p>
                        <ul>
                        <li>Internal record keeping.</li>
                        <li>For improving our products or services.</li>
                        <li>For providing updates to you regarding our products or services including any special offers.</li>
                        <li>To communicate information to you</li>
                        <li>For internal training and quality assurance purposes</li>
                        </ul>
                        <br/>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}><strong>Who do we share your data with</strong></p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}>We may share your information or data with:</p>
                        <ul>
                        <li>Third parties including our service providers in order to facilitate the provisions of goods or services to you, carry out your requests, respond to your queries, fulfil your orders or for other operational and business reasons.</li>
                        <li>With our group companies (to the extent relevant)</li>
                        <li>Our auditors or advisors to the extent required by them for performing their services</li>
                        <li>To communicate information to you</li>
                        <li>Governmental bodies, regulatory authorities, law enforcement authorities pursuant to our legal obligations or compliance requirements.</li>
                        </ul>
                        <br/>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}><strong>How we use cookies</strong></p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}>
                        We use "cookies" to collect information and to better understand customer behaviour. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to avail our goods or services to the full extent. We do not control the use of cookies by third parties. The third party service providers have their own privacy policies addressing how they use such information.
                        </p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}><strong>Your rights relating to your data</strong></p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}><i><u>Right to Review</u></i> - You can review the data provided by you and can request us to correct or amend such data (to the extent feasible, as determined by us). That said, we will not be responsible for the authenticity of the data or information provided by you.</p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}><i><u>Withdrawal of your Consent</u></i> - You can choose not to provide your data, at any time while availing our goods or services or otherwise withdraw your consent provided to us earlier, in writing to our email ID: <strong>{localStorage.getItem("op_email")}</strong> In the event you choose to not provide or later withdraw your consent, we may not be able to provide you our services or goods. Please note that these rights are subject to our compliance with applicable laws.</p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}><strong>How long will we retain your information or data?</strong></p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}>We may retain your information or data (i) for as long as we are providing goods and services to you; and (ii) as permitted under applicable law, we may also retain your data or information even after you terminate the business relationship with us. However, we will process such information or data in accordance with applicable laws and this Policy.</p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}><strong>Data Security</strong></p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}>We will use commercially reasonable and legally required precautions to preserve the integrity and security of your information and data.</p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}><strong>Queries/ Grievance Officer</strong></p>
                        <p style={{ marginLeft: '2px', textAlign: 'justify' }}>For any queries, questions or grievances about this Policy, please contact us using the contact information provided on this website.</p>
                        </Typography>
                    </div>
                </Box>
                )}
             
              </Paper>
            </Grid>
          </Grid>
          </Box>
        </Container>
        
      </main>
    </div>
  );
}
